import React from "react";
import { Box, Checkbox, Typography, Button, CircularProgress } from "@mui/material";
import GenericMUITable from "../../../../components/GenericTable/index";
import { Heading } from "../../../../components/styledConstants";
const RolePermissionsTable = ({ permissions, selectedPermissions, onPermissionToggle, onSave, updating, roleName }) => {
  // Define the columns for the permissions table
  const permissionFields = [
    {
      key: "select",
      label: "Select",
      width: "50px",
      render: (permission) => (
        <Checkbox
          checked={selectedPermissions.has(permission.name)}
          onChange={() => onPermissionToggle(permission.name)}
          size="small"
        />
      ),
    },
    { key: "name", label: "Permission Name" },
    { key: "description", label: "Description" },
  ];

  return (
    <Box>
      <GenericMUITable
        fields={permissionFields}
        data={permissions}
        rowKey="id"
        // Note: You would pass pagination props here if your API supports it.
        // For this use case, we'll assume all permissions are loaded at once.
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={updating}
          style={{ background: "#ED141F" }}
          startIcon={updating ? <CircularProgress size={20} /> : null}
        >
          {updating ? "Updating..." : "Update Permissions"}
        </Button>
      </Box>
    </Box>
  );
};

export default RolePermissionsTable;
